<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มรีวิว <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ชื่อผู้ที่รีวิว&nbsp;<i class="far fa-bookmark"></i>
                  : </label>
                <input class="form-control" v-model="data.review.reviewer" type="text" placeholder="กรุณากรอกชื่อผู้ที่รีวิว">
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <textarea class="form-control" rows="5" v-model="data.review.content"></textarea>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-12 col-sm-12 text-center">
              <div class="row">
                <div class="col-sm-6 col-lg-6">
                  <div class="row">
                    <div class="col-sm-4 col-lg-4"><b>คะแนนที่ให้:</b> </div>
                    <div class="col-sm-8 col-lg-8">
                      <select class="form-control" v-model="data.review.rating">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-6">
                  <div class="row">
                    <div class="col-sm-4 col-lg-4"><b>วันที่รีวิว:</b> </div>
                    <div class="col-sm-8 col-lg-8">
                      <datepicker :bootstrap-styling="true" v-model="data.review.review_date" placeholder="กรุณาคลิกเลือกวันที่รีวิว"
                        review_date></datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name">วันที่สร้าง: </label>
              <datepicker :bootstrap-styling="true" v-model="data.review.created_at" placeholder="กรุณาคลิกเลือกวันที่สร้าง"></datepicker>
            </div>
          </div>
          <div class="col-sm-12" style="margin-top: 40px;">
            <div class="form-group row" v-if="data.image!=''">
              <div class="offset-lg-3 col-lg-6 text-center">
                <label for="ccnumber">รูปตัวอย่าง <i class="far fa-image"></i></label>
                <img v-if="data.image&&data.image!=null" v-bind:src="data.image" @error="imageLoadError" class="d-block w-full">
                <img v-if="data.image===null" v-bind:src="no_image.src" class="d-block w-full">
              </div>
            </div>
            <div class="form-group row">
              <div class="offset-lg-2 col-lg-4">
                <button type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')"><i
                    class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</button>
              </div>
              <div class="col-lg-4">
                <button type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                  อัพโหลดรูปจากลิงค์</button>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
              <button class="btn btn-primary w-full" type="submit" @click="submitReview"><i class="far fa-clipboard-check"></i>
                ยืนยัน</button>
            </div>
            <div class="col-sm-3 col-lg-3">
              <router-link :to="{ name: 'ReviewList'}"><button class="btn btn-secondary w-full" type="button"><i class="far fa-times-square"></i>
                  ยกเลิก</button></router-link>
            </div>
          </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="review.modal.title" ref="model" hide-footer v-model="review.modal.active" @ok="review.modal.active = false">
      <div v-if="review.modal.action=='link'">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">URL</span>
              </div>
              <input type="text" class="form-control" v-model="data.image">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
          </div>
        </div>
      </div>
      <div v-if="review.modal.action=='upload'">
        <div v-if="review.img.upload.active==false">
          <div class="custom-file" v-if="review.img.crop.active">
            <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
          <div v-if="review.img.view.active">
            <div v-if="review.img.crop.active" style="width: 100%; height:68.5%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="review.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                :initialAspectRatio="100/68.5" :aspectRatio="100/68.5" :auto-crop-area="0.5" :min-container-width="100"
                :min-container-height="68.5" :background="true" :rotatable="true" alt="zeedoc-img-review" :img-style="{ 'width': '100%', 'height': '68.5%' }">
              </vue-cropper>
            </div>
            <div>
              <div v-if="!review.img.crop.active">
                <label for="ccnumber">ภาพที่จะแสดงในข้อมูลรีวิว <i class="far fa-image"></i></label>
                <img v-if="review.img.crop.src&&review.img.crop.src!=null" :src="review.img.crop.src" style="width: 100%; height: 68.5%; border: 1px solid gray"
                  alt="ตัวอย่างรูปที่จะนำเข้า" />
                <hr>
              </div>
            </div>
          </div>
          <div class="row" v-if="review.img.crop.active && review.img.view.src">
            <div class="offset-lg-2 col-lg-8">
              <br />
              <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
            </div>
          </div>
          <div class="row" v-if="!review.img.crop.active && review.img.crop.src">
            <div class="col-lg-6">
              <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>
            </div>
          </div>
        </div>
        <div v-if="review.img.upload.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueQuillEditor from 'vue-quill-editor'
  import VueCropper from 'vue-cropperjs'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import Datepicker from 'vuejs-datepicker';
  import uploadImage from '@/components/uploadImage'
  import Helper from '@/shared/helper'
  Vue.use(VueQuillEditor)
  export default {
    components: {
      Datepicker,
      VueCropper,
      uploadImage
    },
    mixins: [Helper],
    data() {
      return {
        load: 0,
        submit: {
          active: false
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        review: {
          id: this.$route.params.id ? parseInt(this.$route.params.id) : null,
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            title: '',
            action: '',
            active: false
          },
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        data: {
          page: 0,
          per_page: 0,
          lang: 'th',
          image: null,
          review: {
            id: '',
            reviewer: '',
            content: '',
            created_at: '',
            review_date: new Date(),
            rating: '2'
          }
        }
      }
    },
    methods: {
      openModal(action) {
        this.review.img.view.active = false
        this.review.modal.action = action
        this.review.img.crop.active = true
        if (action == 'upload') {
          this.review.img.view.src = null
          this.review.modal.title = 'อัพโหลดรูปจากเครื่อง'
          this.review.modal.active = true
        } else if (action == 'link') {
          this.review.modal.title = 'อัพโหลดรูปจากลิงค์'
          this.review.modal.active = true
        }
      },
      submitReview() {
        if (this.review.id != '' && this.review.id) {
          this.checkUpdateReview()
        } else {
          this.checkReview()
        }
      },
      checkReview() {
        this.startLoad(1)
        if (this.data.review.reviewer != '' && this.data.review.reviewer && this.data.review.reviewer.length > 5) {
          this.createReview({
            'reviewer': this.data.review.reviewer,
            'content': this.data.review.content,
            'image': this.data.image,
            'review_date': this.data.review.review_date,
            'created_at': '',
            'rating': this.data.review.rating
          })
        } else {
          this.checkLoad()
          alert("กรุณากรอกชื่อของผู้ที่รีวิวที่มีความยามมากกว่า5ตัวอักษร")
        }
      },
      setImage(e) {
        const file = e.target.files[0]
        this.review.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.review.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      imageLoadError(event) {
        this.data.image = ''
        event.target.src = this.no_image.src
      },
      createReview(data) {
        this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/review', data, {
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.checkLoad()
          alert('ข้อมูลรีวิวสร้างเรียบร้อย');
          this.$router.push({
            name: 'ReviewList'
          })
        }).catch(function (error) {
          alert('ไม่สามารถสร้างรีวิวได้ กรุณากรอกชื่อของผู้ที่รีวิว!');
          this.$router.push({
            name: 'ReviewList'
          })
        })
      },
      async updateReview(data) {
        try {
          await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/review/' + this.review.id, data, {
            headers: {
              Authorization: this.authorization
            }
          })
          alert('ข้อมูลรีวิวอัพเดทเรียบร้อย')
          this.$router.push({
            name: 'ReviewList'
          })
        } catch (e) {
          alert('ไม่สามารถสร้างรีวิวได้ กรุณากรอกชื่อของผู้ที่รีวิว!')
          this.$router.push({
            name: 'ReviewList'
          })
        }
        this.checkLoad()
      },
      async checkUpdateReview() {
        if (this.data.review.reviewer.length > 5) {
          this.submit.active = true
          this.startLoad(1)
          await this.updateReview({
            'id': this.data.review.id,
            'reviewer': this.data.review.reviewer,
            'content': this.data.review.content,
            'image': this.data.image,
            'created_at': this.data.review.created_at,
            'review_date': this.data.review.review_date,
            'rating': this.data.review.rating
          })
        } else {
          // this.checkLoad()
          alert("กรุณากรอกชื่อของผู้ที่รีวิวที่มีความยามมากกว่า5ตัวอักษร")
        }
      },
      cropImage() {
        this.review.img.crop.active = false
        this.review.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      cancleImage() {
        this.review.img.view.src = null
        this.review.img.view.active = false
        this.review.img.crop.active = true
        this.review.img.crop.src = null
      },
      cancleImageLink() {
        this.review.img.view.active = false
        this.review.img.crop.active = true
        this.review.img.crop.src = null
        this.data.image = ''
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      async submitImage() {
        if (this.review.img.crop.src != '' && this.review.img.crop.src) {
          this.review.img.upload.active = true
          try {
            this.data.image = await this.uploadImageDataUrl(this.review.img.crop.src, 'review.jpg')
            this.review.img.upload.active = false
            this.cancleImageLink
            this.$refs.model.hide()
          } catch (error) {
            this.review.img.upload.active = false
            alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
            this.cancleImageLink
            this.$refs.model.hide()
          }
        } else {
          this.review.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      getReviewByID(id) {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/review/' + id, {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            console.log(response.body.json)
            this.data.review.id = response.body.json.id
            this.data.review.reviewer = response.body.json.reviewer
            this.data.review.content = response.body.json.content
            this.data.review.review_date = response.body.json.review_date
            this.data.review.created_at = response.body.json.created_at
            this.data.review.rating = response.body.json.rating
            if (response.body.json.image && response.body.json.image != '') {
              this.data.image = response.body.json.image
            } else {
              this.data.image = this.no_image.src
            }
          }
        }, response => {
          this.checkLoad()
        })
      }
    },
    mounted() {
      if (this.review.id) {
        this.getReviewByID(this.review.id)
      }

    }
  }

</script>
